<template>
	<div>
		<div :class="{pop: loading}" v-if=" type=='sticker' && aucdates && item.auction_order_number" @click="loadLabel" class="sticker">
			<div class="barc">
				<img src="/static/img/odblogo.png" class="odboom" />
				<div class="sticker-head"><span class="aucdates">{{parseAucDates(aucdates)}}</span></div>

				<div class="desc lot">lot</div>
				<div class="desc ib">ib</div>

				<div class="lotnr">{{ item.auction_order_number }}</div>
				<div class="ibcode">{{ item.seller.code }}-{{ item.number }}</div>
				
				<barcode class="bar" :width="1.2" :height="26" :margin="0" :value="createBarcode(item)" :displayValue="false">
				    Barcode niet gegenereerd!
				</barcode>
			</div>
		</div>
		<button v-if="type=='icon'" :class="{pop: loading, dis : !aucdates || !item.auction_order_number}" :disabled="!aucdates || !item.auction_order_number" @click="loadLabel" title="Print DYMO label">
			<i class="fa fa-fw fa-barcode" />
		</button>
	</div>
</template>

<style lang="scss" scoped>
.sticker{
	position: absolute;
	right: -92px;
	top:64px;
	width:264px;
	height: 126px;
	box-shadow: 2px 2px 4px 0 rgba(0,0,0,.6);
	background:white;
	border-radius:20px;
	cursor: pointer;
	&:hover{
		box-shadow: -2px -2px 4px 0 rgba(0,0,0,.6);
	}
	&.pop{
		animation:poplight .3s infinite;
	}
}
.barc{
	color:black;
	width:100%;
	height: 100%;
	position: relative;
	.odboom{
		position: absolute;
		height: 18px;
		margin:10px;
	}
	.sticker-head{
		font-family: Humanist, Arial;
		text-align: center;
		color:rgba(0,0,0,.8);
		font-size: 11px;
		padding:0 16px 0 42px;
		line-height:40px;
		text-align: left;
		.aucdates{
			float:right;
		}
		.logotitle{
			font-family: Cinzel;
			font-weight: bold;
			font-size: 10px
		}
	}
	.lotnr,.ibcode,.desc{
		width:100%;
		text-align: left;
		padding-left: 38px;
		line-height: 45px;
		font-family: Serifa;
		font-size: 30px;
		position: absolute;
		width:100%;
		top:32px;
	}
	.ibcode{
		text-align: right;
		padding-right: 38px;
		font-size: 22px
	}
	.desc{
		font-family: Humanist, Arial;
		font-size: 11px;
		width:40px;
		text-align: center;
		padding: 0;
		line-height: 48px;
		&.ib{
			width:48px;
			right:0;
		}
	}
	.bar{
		position: absolute;
		bottom: 16px;
		width:100%;
		text-align: center;
	}
}
button{
	appearance:none;
	background:transparent;
	border:0;
	padding:4px 8px;
	border-top:1px #007bff solid;
	border-bottom:1px #007bff solid;
	color:#007bff;
	&:hover{
		background:#007bff;
		color:white;
	}
	&.dis,&.dis:hover{
		cursor:default;
		background:transparent;
		color:#999;
		border-top:1px #999 solid;
		border-bottom:1px #999 solid;
	}
	&.pop{
		animation:pop .3s infinite;
	}
}
@keyframes pop{
	0%,100% {
		transform : scale3d(1,1,1);
		border-top:1px #007bff solid;
		border-bottom:1px #007bff solid;
		color:#007bff;
	}
	50%{
		transform : scale3d(.95,.95,.95);
		border-top:1px green solid;
		border-bottom:1px green solid;
		color:green;
	}
}
@keyframes poplight{
	0%,100% {
		transform : scale3d(1,1,1);
	}
	50%{
		transform : scale3d(.99,.99,.99);
	}
}
</style>

<script>
import VueBarcode from 'vue-barcode';
import axios from 'axios'

export default {

	name: 'app',
	data() {
		return {
			barcodeLabel : false,
			loading:false
		}
	},
	methods:{
		parseAucDates(dates){
			let datestr = '';
			let months = ['','jan','feb','maa','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
			if(typeof dates == 'object' && typeof dates.start != 'undefined'){
				let start = dates.start.substr(0,10).split('-');
				let end = dates.end.substr(0,10).split('-');
				datestr+=parseInt(start[2]) + ' ';
				if(start[1] != end[1]){
					datestr+=months[parseInt(start[1])];
				}
				datestr+=' - ' + parseInt(end[2]) + ' ' + months[parseInt(end[1])] + ' ' + end[0];
				return datestr;
			}
		},
		createBarcode(item){
			let auctionId 			= this.pad(item.auction_id, 4);
			let paddedItemId 		= this.pad(item.id, 6);
			let paddedSellerID 		= this.pad(item.seller.id, 6);
			let paddedOrderNumber 	= this.pad(item.auction_order_number, 6);
			return auctionId + paddedItemId + paddedSellerID + paddedOrderNumber;
		},
		pad(val,len){
			let padded = String(val);
			while(padded.length < len){
				padded='0' + padded;
			}
			return padded;
		},
		loadLabel(){

			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 5000);
			
			let replaceObj = {
				'BARCODE' 	: this.createBarcode(this.item),
				'AUCDATES' 	: this.parseAucDates(this.aucdates),
				'ORDERNR' 	: this.item.auction_order_number,
				'IBCODE' 	: this.item.seller.code + '-' + this.item.number
			}
			 axios.get('/static/labels/standaard-odb-dubbel.label').then( (response) => {

			 	let label = response.data;
			 	for(let k in replaceObj){
			 		label = label.replace('##' + k + '##',replaceObj[k]);
			 	}
			 	this.barcodeLabel = label;

			 	this.printLabel();

			 });

		},
		printLabel(){
			var label = dymo.label.framework.openLabelXml(this.barcodeLabel);
            var printers = dymo.label.framework.getPrinters();
            if (printers.length == 0)
                throw "No DYMO printers are installed. Install DYMO printers.";

            var printerName = "";
            for (var i = 0; i < printers.length; ++i)
            {
                var printer = printers[i];
                if (printer.printerType == "LabelWriterPrinter")
                {
                    printerName = printer.name;
                    break;
                }
            }

            if (printerName == "")
                throw "No LabelWriter printers found. Install LabelWriter printer";

            label.print(printerName);
		}
	},
	mounted(){
		
	},
	computed:{
		fa(){
			if(this.loading){
				return 'fa-cog';
			}
			return 'fa-barcode';
		}
	},
	props : [
		'item',
		'aucdates',
		'type'
	],
	components : {
		'barcode': VueBarcode
	}
};
</script>



// WEBPACK FOOTER //
// ODBBarcode.vue?eb2573e4